module.exports = __webpack_public_path__ + "img/bb2c0d5b5d90def26f69b31fcd83f2e9.bb2c0d5b.png";